import { Component, type ReactNode } from 'react';
import { Intent } from '@blueprintjs/core';
import { Focusable, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import cx from 'clsx';

import { Notifications } from '../../../notifications/components/Notifications';

import './styles.scss';

type CopyToClipboardProps = Readonly<{
  content: string;
  children?: ReactNode;
  className?: string;
}>;

export class CopyToClipboard extends Component<CopyToClipboardProps> {
  private inputRef!: HTMLInputElement;

  public render() {
    const { content, children, className } = this.props;

    return (
      <div className={cx(className, 'CopyToClipboard')}>
        <input value={content} readOnly ref={this.setInputRef} />
        <TooltipTrigger>
          <Focusable>
            {/* oxlint-disable-next-line jsx-a11y/click-events-have-key-events -- adding real keyboard activation here is a UX change, out of scope */}
            <span role="button" tabIndex={0} onClick={this.handleClick} style={{ cursor: 'pointer' }}>
              {children}
            </span>
          </Focusable>
          <Tooltip placement="top" variant="popover">
            Copy
          </Tooltip>
        </TooltipTrigger>
      </div>
    );
  }

  private setInputRef = (node: HTMLInputElement) => {
    this.inputRef = node;
  };

  private handleClick = () => {
    this.inputRef.select();
    document.execCommand('copy');

    // Show toast notification
    Notifications.show({
      intent: Intent.SUCCESS,
      message: 'Copied to clipboard!',
    });
  };
}
